export const trimGuardText = (text?: string | null): string => {
  return text?.replace(/\uFEFF/g, '') || '';
};

export default trimGuardText;